// src/phase4/types/tower.ts
// Tower-related type definitions for Phase 4 tower defense system

/** Tower type enumeration */
export enum TowerType {
  CPU_MAIN = 'CPU_MAIN',
  LANGUAGE_SIDE = 'LANGUAGE_SIDE',
  NETWORK_SIDE = 'NETWORK_SIDE',
}

/** Special effect types that towers can apply */
export type SpecialEffectType =
  | 'critical'    // Critical hit chance
  | 'slow'         // Slow effect on enemy
  | 'pierce'       // Pierce through enemies
  | 'shield'       // Shield effect (self or ally)
  | 'aoe';         // Area of effect damage

/** Special effect configuration */
export interface SpecialEffect {
  type: SpecialEffectType;
  value: number; // Effect value (e.g., 0.15 = 15% crit chance, 0.3 = 30% slow)
  duration?: number; // Duration in ms (if applicable)
}

/** Individual tower level configuration */
export interface TowerLevelConfig {
  level: number;
  name: string;
  dps: number;
  range: number;
  fireRate: number; // ms per shot
  specialEffects?: SpecialEffect[];
  upgradeCost: number;
  // Resource paths
  textureKey: string;
  animationPrefix?: string;
}

/** Complete upgrade path for a tower type */
export interface TowerUpgradePath {
  towerType: TowerType;
  pathName: string;
  levels: TowerLevelConfig[];
}

/** Runtime tower instance state */
export interface TowerInstance {
  id: string;
  type: TowerType;
  currentLevel: number;
  x: number;
  y: number;
  // Runtime state
  targetId: string | null;
  lastFireTime: number;
  specialEffectActive?: {
    type: SpecialEffectType;
    expiresAt: number;
  };
}

/** Tower upgrade request */
export interface TowerUpgradeRequest {
  towerId: string;
  targetLevel: number;
}

/** Tower selection for UI */
export interface TowerSelection {
  towerId: string;
  x: number;
  y: number;
}
